import { useId } from "react";

/**
 * Voided / Deleted submittal badge.
 * Design: 42×42 container (#F5F5F5), 24×24 glyph centered.
 */
export default function SubmittalVoidedDeletedCiqIcon({
  size = 42,
  className = ""
}: {
  size?: number;
  className?: string;
}) {
  const clipId = useId().replace(/:/g, "");

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="42" height="42" rx="4" fill="#F5F5F5" />
      <path
        d="M21.2415 15.2753H30.8576C31.3317 15.2753 31.7147 15.6584 31.7147 16.1325V24.597C31.151 23.8299 30.6571 23.5585 29.7861 23.2973V17.2039H20.4674L17.2638 14.1396H12.2147V27.8539H22.7815C22.7815 28.6094 22.7815 28.9377 23.1892 29.7825H11.1433C10.6692 29.7825 10.2861 29.3995 10.2861 28.9253V13.0682C10.2861 12.5941 10.6692 12.2111 11.1433 12.2111H17.9522C18.007 12.2115 18.0595 12.2326 18.0995 12.27L21.2415 15.2753Z"
        fill="#CECECE"
      />
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M28 23.625C25.584 23.625 23.625 25.584 23.625 28C23.625 30.416 25.584 32.375 28 32.375C30.416 32.375 32.375 30.416 32.375 28C32.375 25.584 30.416 23.625 28 23.625ZM29.6152 29.6621L28.9707 29.6592L28 28.502L27.0303 29.6582L26.3848 29.6611C26.3418 29.6611 26.3066 29.627 26.3066 29.583C26.3066 29.5645 26.3135 29.5469 26.3252 29.5322L27.5957 28.0186L26.3252 26.5059C26.3134 26.4915 26.3068 26.4736 26.3066 26.4551C26.3066 26.4121 26.3418 26.377 26.3848 26.377L27.0303 26.3799L28 27.5371L28.9697 26.3809L29.6143 26.3779C29.6572 26.3779 29.6924 26.4121 29.6924 26.4561C29.6924 26.4746 29.6855 26.4922 29.6738 26.5068L28.4053 28.0195L29.6748 29.5332C29.6865 29.5479 29.6934 29.5654 29.6934 29.584C29.6934 29.627 29.6582 29.6621 29.6152 29.6621Z"
          fill="black"
          fillOpacity="0.45"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(23 23)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
